/**
 * Maps backend grade tokens to display labels (e.g. A_P → A+).
 */
export enum Grade {
  A_P = "A+",
  A = "A",
  B_P = "B+",
  B = "B",
  C_P = "C+",
  C = "C",
  D = "D",
  E = "E",
  E1 = "E1",
  E2 = "E2",
}

export enum AssessmentType {
  SAHITYIK = "SAHITYIK",
  SANSKRITIK = "SANSKRITIK",
  VAIGYANIK = "VAIGYANIK",
  SRIJANATMAK = "SRIJANATMAK",
  KHELKUD = "KHELKUD",
  REGULARITY = "REGULARITY",
  CLEANLINESS = "CLEANLINESS",
  DISCIPLINE = "DISCIPLINE",
  COOPERATION = "COOPERATION",
  ENVIRONMENT = "ENVIRONMENT",
  LEADERSHIP = "LEADERSHIP",
  HONESTY = "HONESTY",
}

export function formatBackendGradeForUi(grade?: string | null): string {
  if (grade == null || grade === "") return "";
  const g = String(grade).trim();
  if (g.startsWith("A_P")) return "A+";
  if (g.startsWith("B_P")) return "B+";
  if (g.startsWith("C_P")) return "C+";
  return g;
}

/** Overall total grade line: map A_P/B_P/C_P, otherwise uppercase (legacy marksheet behavior). */
export function formatTotalGradeForDisplay(totalGrade?: string | null): string {
  const g = totalGrade?.trim();
  if (!g) return "";
  if (g.startsWith("A_P") || g.startsWith("B_P") || g.startsWith("C_P")) {
    return formatBackendGradeForUi(g);
  }
  return g.toUpperCase();
}
